<template>
  <dl>
    <dt>客室数</dt>
    <dd>
      <p class="hotelNumberItem">
        <select :value="numOfRooms" @change="changeRoomNumber">
          <option v-for="i in maxRoomCount" :key="i" :value="i">
            {{ i }}室
          </option>
        </select>
      </p>
    </dd>
  </dl>
</template>

<script>
export default {
  name: 'RoomNumInput',
  model: {
    prop: 'roomNumber',
  },
  props: {
    roomNumber: {
      type: Number,
      required: true,
    },
    maxRoomCount: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      numOfRooms: Math.min(this.roomNumber, this.maxRoomCount),
    }
  },
  methods: {
    changeRoomNumber(e) {
      this.$emit('input', parseInt(e.target.value))
    },
  },
}
</script>
